import { createContext } from "react";

export interface SidebarContextValue {
  forceExpanded?: boolean;
  setFlyoutPointerInside?: (inside: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextValue>({});
